import React from "react";

const LocationIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" {...props}>
      <g data-name="Grupo 2555">
        <g data-name="Grupo 2551">
          <path
            data-name="Trazado 1225"
            d="M9.059 24a1.209 1.209 0 0 0 .967-.5l6.772-9.635.039-.038a9.072 9.072 0 0 0-1.316-11.186 9.1 9.1 0 0 0-14.2 11.183c0 .038.039.038.039.077l6.81 9.634a1.027 1.027 0 0 0 .89.465ZM4.223 4.266a6.866 6.866 0 0 1 9.634 0 6.734 6.734 0 0 1 1.007 8.28l-5.8 8.281-5.842-8.281a6.793 6.793 0 0 1 1.006-8.28Zm0 0"
            fill="#c8c8c8"
          />
        </g>
        <g data-name="Grupo 2554">
          <path
            data-name="Trazado 1227"
            d="M12.851 9.335a3.947 3.947 0 1 0-3.947 3.947 3.963 3.963 0 0 0 3.947-3.947ZM8.904 10.96a1.625 1.625 0 1 1 1.625-1.625 1.66 1.66 0 0 1-1.625 1.625Zm0 0"
            fill="#c8c8c8"
          />
        </g>
      </g>
    </svg>
  );
};

export default LocationIcon;
